import { getDimensionLabel } from './getDimensionLabel';
import { getDimensionDataProperties } from './getDimensionDataProperties';
import { getDimensionData } from './getDimensionData';
import { WebAPILineGraphChartSlicerData } from '../../../../globals/webApiTypes/elements/WebAPICBS';
import { ValuesByDimension } from '../lineGraph.types';
import { chartColors } from '../LineGraph.styles';

export const getDimensionInfo = ({
	dimensionKeys,
	multiDimension,
	valuesByDimension,
	periodDatesInRange,
	selectedTopics,
	selectedCategories,
	labelAliases,
}: {
	dimensionKeys: Array<string>;
	multiDimension: WebAPILineGraphChartSlicerData['multiDimension'];
	valuesByDimension: ValuesByDimension;
	periodDatesInRange: Array<Date>;
} & Pick<
	WebAPILineGraphChartSlicerData,
	'selectedTopics' | 'selectedCategories' | 'labelAliases'
>) => {
	const dimensionInfo = dimensionKeys.map((dimensionKey) => {
		const dimensionLabel = getDimensionLabel({
			multiDimension,
			selectedTopics,
			selectedCategories,
			labelAliases,
			dimensionKey,
		});

		const dimensionDataProperties = getDimensionDataProperties({
			dimensionKey,
			valuesByDimension,
		});

		const { dimensionData, filteredDimensionData } = getDimensionData({
			periodDatesInRange,
			dimensionKey,
			valuesByDimension,
		});

		return {
			dimensionKey,
			dimensionLabel,
			dimensionData,
			filteredDimensionData,
			...dimensionDataProperties,
		};
	});

	const sortedDimensionInfo = dimensionInfo.sort((a, b) =>
		b.average != null && a.average != null ? b.average - a.average : 0,
	);

	const sortedDimensionInfoWithChartColors = sortedDimensionInfo.map(
		(singleDimensionInfo, index) => ({
			...singleDimensionInfo,
			chartColor: chartColors[index],
		}),
	);

	return sortedDimensionInfoWithChartColors;
};
